// extracted by mini-css-extract-plugin
export default {"ModalHeader":"ModalHeader_ModalHeader__mrBCZ","label":"ModalHeader_label__L1neJ"};